import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const TemperatureConverterGuidePage = () => <DataDrivenGuidePage slug="guide-temperature-calculator" />;

export default TemperatureConverterGuidePage;
